import { db, FirebaseDocRefType } from 'firebase/index'
import { dateToString } from 'lib/helper'
import { CheckoutItemType } from 'types/checkoutItem'
import { CheckoutStatusType, CheckoutType } from 'types/checkout'
import { StockUnionType } from '../types/stock'

export const fetchCheckoutByRef = (checkoutRef: FirebaseDocRefType): Promise<CheckoutType | undefined> => {
  return checkoutRef
    .get()
    .then((snapshot) => {
      const data = snapshot.data() as CheckoutType
      data.checkout_id = snapshot.id
      return data
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}
export const fetchCheckoutsByDate = (params: {
  storeRef: FirebaseDocRefType
  date: string
  status: CheckoutStatusType[]
  types: StockUnionType[]
}): Promise<CheckoutType[] | undefined> => {
  const { storeRef, date, status, types } = params
  return storeRef
    .collection('store_checkouts')
    .where('status', 'in', status)
    .where('date', '==', date)
    .get()
    .then((snapshots) => {
      const checkouts: CheckoutType[] = []
      snapshots.docs.forEach((snapshot) => {
        const data = snapshot.data() as CheckoutType
        if (!types.includes(data.type)) {
          return
        }
        data.checkout_id = snapshot.id
        checkouts.push(data)
      })
      return checkouts
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchCheckoutItemsByBreadRef = (
  breadRef: FirebaseDocRefType,
  startOfMonth: Date,
  endOfMonth: Date
): Promise<CheckoutItemType[]> => {
  return db
    .collectionGroup('store_checkout_items')
    .where('bread_ref', '==', breadRef)
    .orderBy('date', 'asc')
    .startAt(dateToString(startOfMonth))
    .endAt(dateToString(endOfMonth))
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as CheckoutItemType
        data.checkout_id = snapshot.ref.parent.parent?.id
        data.checkout_item_ref = snapshot.ref
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const fetchStoreCheckouts = (storeRef: FirebaseDocRefType): Promise<CheckoutType[]> => {
  return storeRef
    .collection('store_checkouts')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as CheckoutType
        data.checkout_id = snapshot.ref.id
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}
